import { __assign, __read } from "tslib";
import { mergeClasses, useArrowNavigationGroup, } from '@fluentui/react-components';
import { format } from '@office-start/string-formatter-utility';
import React, { useCallback, useMemo, useState } from 'react';
import { useCarouselNavControlStyles } from './CarouselNavControl.styles';
import { CarouselNavIcon } from './CarouselNavIcon';
// $TODO: Split the buttons into their own component.
export var CarouselNavControl = function (_a) {
    var carouselResources = _a.carouselResources, disableNavigationControls = _a.disableNavigationControls, handleNavKeyDown = _a.handleNavKeyDown, isFirstPage = _a.isFirstPage, isLastPage = _a.isLastPage, isRtl = _a.isRtl, isVisualRefresh = _a.isVisualRefresh, navPrevious = _a.navPrevious, navNext = _a.navNext, displayedPage = _a.displayedPage, pageCount = _a.pageCount;
    var styles = useCarouselNavControlStyles();
    var _b = __read(useState(false), 2), chevRightFilled = _b[0], setChevRightFilled = _b[1];
    var _c = __read(useState(false), 2), chevLeftFilled = _c[0], setChevLeftFilled = _c[1];
    // Determines if article containing navLabel will be active or not (If there's only one page in carousel then it shouldn't render the article)
    var showNavLabel = useMemo(function () {
        if (disableNavigationControls || (isFirstPage && isLastPage)) {
            return false;
        }
        else {
            return true;
        }
    }, [disableNavigationControls, isFirstPage, isLastPage]);
    // Gets the formatted string for the screenReader to announce (current page of carousel)
    var navLabel = useMemo(function () {
        if (showNavLabel) {
            return format(carouselResources.navigationAriaDescription, displayedPage.toString(), pageCount.toString());
        }
        return undefined;
    }, [
        showNavLabel,
        displayedPage,
        pageCount,
        carouselResources.navigationAriaDescription,
    ]);
    var onNavNextCallback = useCallback(function (_e) {
        navNext();
    }, [navNext]);
    var onNavPreviousCallback = useCallback(function (_e) {
        navPrevious();
    }, [navPrevious]);
    var previousClassNames = isFirstPage || disableNavigationControls
        ? mergeClasses(styles.carouselNavBase, styles.carouselNavDisabled)
        : styles.carouselNavBase;
    var onMouseEnterPreviousCallback = useCallback(function () {
        if (!isFirstPage && !disableNavigationControls) {
            setChevLeftFilled(true);
        }
    }, [disableNavigationControls, isFirstPage]);
    var onMouseLeavePreviousCallback = useCallback(function () {
        if (chevLeftFilled) {
            setChevLeftFilled(false);
        }
    }, [chevLeftFilled]);
    var nextClassName = isLastPage || disableNavigationControls
        ? mergeClasses(styles.carouselNavBase, styles.carouselNavDisabled)
        : styles.carouselNavBase;
    var onMouseEnterNextCallback = useCallback(function () {
        if (!isLastPage && !chevRightFilled && !disableNavigationControls) {
            setChevRightFilled(true);
        }
    }, [chevRightFilled, disableNavigationControls, isLastPage]);
    var onMouseLeaveNextCallback = useCallback(function () {
        if (chevRightFilled) {
            setChevRightFilled(false);
        }
    }, [chevRightFilled]);
    var arrowKeyAttributes = useArrowNavigationGroup({
        circular: true,
        axis: 'horizontal',
        memorizeCurrent: false,
        tabbable: false,
    });
    return (React.createElement("div", __assign({ className: isVisualRefresh
            ? mergeClasses(styles.carouselNav, styles.carouselNavRefresh)
            : styles.carouselNav }, arrowKeyAttributes),
        showNavLabel ? (React.createElement("article", { "aria-live": "polite", "aria-label": navLabel })) : null,
        React.createElement("div", { onMouseEnter: onMouseEnterPreviousCallback, onMouseLeave: onMouseLeavePreviousCallback, onKeyDown: function (event) {
                return handleNavKeyDown(event, -1 /* CarouselNavigationDirection.NavPrevious */);
            }, "aria-label": carouselResources.previousAriaLabel, "aria-disabled": isFirstPage || disableNavigationControls, title: carouselResources.previousTooltip, className: previousClassNames, onClick: onNavPreviousCallback, role: "button", tabIndex: isFirstPage || disableNavigationControls ? -1 : 0 },
            React.createElement(CarouselNavIcon, { isFilled: chevLeftFilled, isRtl: isRtl, navigationDirection: "previous", isDisabled: isFirstPage || disableNavigationControls })),
        React.createElement("div", { onMouseEnter: onMouseEnterNextCallback, onMouseLeave: onMouseLeaveNextCallback, onKeyDown: function (event) {
                return handleNavKeyDown(event, 1 /* CarouselNavigationDirection.NavNext */);
            }, "aria-label": carouselResources.nextAriaLabel, "aria-disabled": isLastPage || disableNavigationControls, title: carouselResources.nextTooltip, className: nextClassName, onClick: onNavNextCallback, role: "button", tabIndex: isLastPage || disableNavigationControls ? -1 : 0 },
            React.createElement(CarouselNavIcon, { isFilled: chevRightFilled, isRtl: isRtl, navigationDirection: "next", isDisabled: isLastPage || disableNavigationControls }))));
};
//# sourceMappingURL=CarouselNavControl.js.map